import { z } from 'zod';
import { order } from '@schuettflix/schema-registry-ts';

export const PRODUCT_TYPE_SCHEMA = order.orderService.versions.v1.schemas.PRODUCT_TYPE_SCHEMA;

export type PRODUCT_TYPES = z.infer<typeof PRODUCT_TYPE_SCHEMA>;

export type SERVICE_PRODUCT_TYPES_VALUE = Extract<
    PRODUCT_TYPES,
    | 'CUSTOM_SERVICE_ACCOMPANYING_DOCUMENT'
    | 'CUSTOM_SERVICE_ANALYSIS'
    | 'CUSTOM_SERVICE_WAITING_TIME'
    | 'CUSTOM_SERVICE_TOLL'
>;

export type SERVICE_PRODUCT_TYPES_PLACEHOLDER = Extract<PRODUCT_TYPES, 'CUSTOM_SERVICE' | 'CUSTOM_SERVICE_TRANSPORT'>;

// This implementation should be refined when we have multiple product channels
export const PRODUCT_CHANNELS = z.enum(['CUSTOM', 'MATERIAL', 'TRANSPORT', 'NO_CHANNEL']);
export type PRODUCT_CHANNELS_TYPES = z.infer<typeof PRODUCT_CHANNELS>;

export const PRODUCT_CHANNEL_TYPES: Record<PRODUCT_TYPES, PRODUCT_CHANNELS_TYPES> = {
    // =================================
    // Handled by custom-request-service
    // =================================
    // Materials
    CUSTOM_BULK_MATERIAL: PRODUCT_CHANNELS.Values.CUSTOM,
    CUSTOM_RECYCLED_BULK_MATERIAL: PRODUCT_CHANNELS.Values.CUSTOM,
    CUSTOM_ASPHALT: PRODUCT_CHANNELS.Values.CUSTOM,
    CUSTOM_CONCRETE: PRODUCT_CHANNELS.Values.CUSTOM,
    // Waste
    CUSTOM_NON_HAZARDOUS_WASTE_DISPOSAL: PRODUCT_CHANNELS.Values.CUSTOM,
    CUSTOM_NON_HAZARDOUS_WASTE_RECYCLING: PRODUCT_CHANNELS.Values.CUSTOM,
    CUSTOM_HAZARDOUS_WASTE_DISPOSAL: PRODUCT_CHANNELS.Values.CUSTOM,
    CUSTOM_HAZARDOUS_WASTE_RECYCLING: PRODUCT_CHANNELS.Values.CUSTOM,
    // Transports
    CUSTOM_TRANSPORT: PRODUCT_CHANNELS.Values.CUSTOM,
    // Material Services
    CUSTOM_SERVICE: PRODUCT_CHANNELS.Values.CUSTOM,
    CUSTOM_SERVICE_ACCOMPANYING_DOCUMENT: PRODUCT_CHANNELS.Values.CUSTOM,
    CUSTOM_SERVICE_ANALYSIS: PRODUCT_CHANNELS.Values.CUSTOM,
    // Transport Services
    CUSTOM_SERVICE_TRANSPORT: PRODUCT_CHANNELS.Values.CUSTOM,
    CUSTOM_SERVICE_WAITING_TIME: PRODUCT_CHANNELS.Values.CUSTOM,
    CUSTOM_SERVICE_TOLL: PRODUCT_CHANNELS.Values.CUSTOM,
    // ===================================
    // Handled by material-channel-service
    // ===================================
    // Materials
    BULK_MATERIAL: PRODUCT_CHANNELS.Values.MATERIAL,
    RECYCLED_BULK_MATERIAL: PRODUCT_CHANNELS.Values.MATERIAL,
    // Waste
    NON_HAZARDOUS_WASTE_DISPOSAL: PRODUCT_CHANNELS.Values.MATERIAL,
    NON_HAZARDOUS_WASTE_RECYCLING: PRODUCT_CHANNELS.Values.MATERIAL,
    HAZARDOUS_WASTE_DISPOSAL: PRODUCT_CHANNELS.Values.MATERIAL,
    HAZARDOUS_WASTE_RECYCLING: PRODUCT_CHANNELS.Values.MATERIAL,
    // ============================
    // Handled by transport-service
    // ============================
    TRANSPORT: PRODUCT_CHANNELS.Values.TRANSPORT,
    // ==============================
    // No channel — synthesized at fulfillment time
    // ==============================
    SERVICE_TOLL: PRODUCT_CHANNELS.Values.NO_CHANNEL,
    SERVICE_WEIGHING_NOTE: PRODUCT_CHANNELS.Values.NO_CHANNEL,
    SERVICE_ACCOMPANYING_DOCUMENT: PRODUCT_CHANNELS.Values.NO_CHANNEL,
    SERVICE_ENERGY_SURCHARGE: PRODUCT_CHANNELS.Values.NO_CHANNEL,
};

export const PROCESSING_TYPE_SCHEMA = z.enum(['AUTOMATIC', 'MANUAL']);
export type PROCESSING_TYPE = z.infer<typeof PROCESSING_TYPE_SCHEMA>;

export const ADDITIONAL_SERVICE_PRODUCT_TYPE_SCHEMA = PRODUCT_TYPE_SCHEMA.extract([
    'SERVICE_TOLL',
    'SERVICE_WEIGHING_NOTE',
    'SERVICE_ACCOMPANYING_DOCUMENT',
    'SERVICE_ENERGY_SURCHARGE',
]);
export type ADDITIONAL_SERVICE_PRODUCT_TYPE = z.infer<typeof ADDITIONAL_SERVICE_PRODUCT_TYPE_SCHEMA>;
